import { useSelector } from "react-redux";
import { RootState } from "../store";

export const usePosterReducers = () => {
    return useSelector((state: RootState) => state.combinedReducer.posterReducers);
  };